import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import SBComponentVue from '@/components/SBComponentVue';


@Component({
})
export default class SBArtistListCategoryIcon extends Mixins(SBComponentVue) {
}
